export default "__VITE_ASSET__PSOI7XDP__"